<template>
  <div class="law-page">
    <div class="top-banner">
      <img src="https://boling-cloud.oss-cn-beijing.aliyuncs.com/dist/img/product-bg.png" alt="Banner" class="banner-image" />

      <div class="banner-info">
        <div class="title">医疗器械行业数据</div>
        <div class="space"></div>
        <div class="info">严格遵循ALCOA+原则（可归因、清晰、同步、原始、准确、完整），并通过闭环管理确保数据从采集到销毁的全周期合规。</div>
        <div class="info">簙引结合数据处理工具（如SQL、Python、JMP）实现高效的数据治理。</div>
        <div class="btn">
          <img src="https://boling-cloud.oss-cn-beijing.aliyuncs.com/dist/img/btn.png" class="btn" alt="">
        </div>
      </div>
    </div>

    <div class="law-main">
      <div class="section-title">
        <h2>服务介绍</h2>
        <div class="title-underline"></div>
      </div>
      
      <div class="service-list">
        <div class="item" v-for="(item, i) in serviceList" :key="i">
          <img :src="item.url" alt="">
          <div class="item-title">{{ item.title }}</div>
          <div class="item-desc">{{ item.desc }}</div>
        </div>
      </div>

      <div class="law-table">
        <Swipe :autoplay="5000" :loop="true" :touchable="true" :show-indicators="false">
          <SwipeItem>
            <div class="banner-item">
              <div class="info">
                <div class="title">全方位数据对接</div>
                <div class="item">
                  <div class="label">
                    <Icon name="success" color="#68BBC4" size="20"/>
                    数据采集
                  </div>
                  <div class="desc">通过全渠道接入即时采集官方数据。</div>
                </div>
                <div class="item">
                  <div class="label">
                    <Icon name="success" color="#68BBC4" size="20"/>
                    数据整合
                  </div>
                  <div class="desc">库内共有16类数据信息，统一清洗、更新、去重。</div>
                </div>
                <div class="item">
                  <div class="label">
                    <Icon name="success" color="#68BBC4" size="20"/>
                    数据存储
                  </div>
                  <div class="desc">利用安全高效的数据仓库，支持大规模存储与随时调用。</div>
                </div>
              </div>
              <div class="bg-box">
                <img src="https://boling-cloud.oss-cn-beijing.aliyuncs.com/dist/img/medical1.png" class="table-bg" alt="" @dragstart.prevent>
                <img src="https://boling-cloud.oss-cn-beijing.aliyuncs.com/dist/img/medical-item1.png" class="item-img" alt="" @dragstart.prevent>
              </div>
            </div>
          </SwipeItem>
          <SwipeItem>
            <div class="banner-item">
              <div class="info">
                <div class="title">在线数据分析</div>
                <div class="item">
                  <div class="label">
                    <Icon name="success" color="#68BBC4" size="20"/>
                    数据建模
                  </div>
                  <div class="desc">通过算法快速构建分析模型。</div>
                </div>
                <div class="item">
                  <div class="label">
                    <Icon name="success" color="#68BBC4" size="20"/>
                    数据可视化
                  </div>
                  <div class="desc">生成直观的图表与报告，便于解读。</div>
                </div>
                <div class="item">
                  <div class="label">
                    <Icon name="success" color="#68BBC4" size="20"/>
                    数据洞察
                  </div>
                  <div class="desc">基于多维分析揭示潜在机会与风险。</div>
                </div>
              </div>
              <div class="bg-box">
                <img src="https://boling-cloud.oss-cn-beijing.aliyuncs.com/dist/img/medical2.png"  class="table-bg" alt="" @dragstart.prevent>
                <img src="https://boling-cloud.oss-cn-beijing.aliyuncs.com/dist/img/medical-item2.png" class="item-img2" alt="" @dragstart.prevent>
                <img src="https://boling-cloud.oss-cn-beijing.aliyuncs.com/dist/img/medical-item3.png" class="item-img3" alt="" @dragstart.prevent>
              </div>
            </div>
          </SwipeItem>
        </Swipe>
      </div>


      <div class="section-title">
        <h2>优势分析</h2>
        <div class="title-underline"></div>
      </div>

      <div class="good-box">
        <div class="good-item" v-for="(item, i) in goodList" :key="i">
          <div class="title">
            <span class="text">{{ item.title }}</span>
          </div>
          <div class="item">
            <div class="label">{{ item.label }}</div>
            <div class="desc">
              <Icon name="success" color="#68BBC4" size="20"/>
              {{ item.desc1 }}
            </div>
            <div class="desc">
              <Icon name="success" color="#68BBC4" size="20"/>
              {{ item.desc2 }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { Swipe, SwipeItem, Icon } from 'vant';
import '@vant/touch-emulator'


const serviceList = [
  {
    url: new URL('https://boling-cloud.oss-cn-beijing.aliyuncs.com/dist/img/service-1.png', import.meta.url).href,
    title: '数据收集与整合',
    desc: '确定数据来源，确保数据符合法规的采集要求。'
  },
  {
    url: new URL('https://boling-cloud.oss-cn-beijing.aliyuncs.com/dist/img/service-2.png', import.meta.url).href,
    title: '数据标签体系化',
    desc: '构建可视化的标签，满足过程管理对数据质量的要求。'
  },
  {
    url: new URL('https://boling-cloud.oss-cn-beijing.aliyuncs.com/dist/img/service-3.png', import.meta.url).href,
    title: '数据存储与安全管理',
    desc: '确保数据存储符合隐私保护和可追溯性要求。'
  },
  {
    url: new URL('https://boling-cloud.oss-cn-beijing.aliyuncs.com/dist/img/service-4.png', import.meta.url).href,
    title: '数据分析',
    desc: '满足长期保存要求，安全销毁冗余数据。'
  },
  {
    url: new URL('https://boling-cloud.oss-cn-beijing.aliyuncs.com/dist/img/service-5.png', import.meta.url).href,
    title: '生成可视化报告',
    desc: '将分析结果转化为监管机构或内部决策者可理解的格式。'
  },
  {
    url: new URL('https://boling-cloud.oss-cn-beijing.aliyuncs.com/dist/img/service-6.png', import.meta.url).href,
    title: '数据归档',
    desc: '从数据中提取决策所需的证据（如风险-收益分析、不良事件趋势）'
  },
]

const goodList = [
  {
    title: '全方位服务',
    label: '专业团队，全面支持',
    desc1: '提供多对一陪伴式服务，确保每一步顺利推进。',
    desc2: '系统实时监控，快速响应，为客户提供持续保障。'
  },
  {
    title: '动态更新',
    label: '效用一体，即时抓取',
    desc1: '数据每日更新，实时反映行业动态与趋势。',
    desc2: '及时捕捉市场变化，抢读一手资讯。'
  },
  {
    title: '一键监测',
    label: '全面客观，快速分析',
    desc1: '通过数据监测竞争对手动态，分析行业竞争格局。',
    desc2: '助力企业制定差异化策略。'
  },
  {
    title: '降本增效',
    label: '丰富信息，定价合理',
    desc1: '订阅成本远低于自建数据团队。',
    desc2: '企业将资源集中于核心业务，加倍实现降本增效。'
  },
]

</script>

<style lang="less" scoped>
.law-page {
  position: relative;
  min-height: 100vh;
  min-width: 1400px;
  background: #fff;
  padding-bottom: 30px;
  
  .banner-info {
    position: absolute;
    right: 100px;
    top: 0;
    height: 600px;
    padding-bottom: 60px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-end;
    
    .title {
      font-family: YouSheBiaoTiHei;
      font-size: 72px;
      line-height: 90px;
      color: #101010;
    }
    
    .space {
      width: 160px;
      height: 24px;
      margin: 32px 0 44px;
      background: linear-gradient(228.23deg, rgba(35,19,176,0.83) 12.42%,rgba(128,152,219,0.9) 47.6%,rgba(135,183,219,0.82) 73.98%,rgba(165,227,255,0.75) 97.43%);
    }
    
    .info {
      
      font-size: 20px;
      line-height: 35px;
      color: #101010;
      text-align: right;
    }
    
    .btn {
      margin-top: 40px;
      
      img {
        width: 200px;
        cursor: pointer;
        transition: all .3s;
        
        &:hover {
          transform: scale(1.02);
        }
      }
    }
  }

  .top-banner {
    width: 100%;
    height: 600px;
    overflow: hidden;
    
    .banner-image {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
  }

  .law-main {
    padding: 60px 0;
    
    .section-title {
      text-align: center;
      margin-bottom: 60px;
      
      h2 {
        
        font-size: 48px;
        color: #101010;
        margin-bottom: 10px;
      }
      
      .title-underline {
        width: 440px;
        height: 7px;
        background: #1e40af;
        margin: 0 auto;
      }
    }

    
  }


  .law-table {
    width: 1400px;
    height: 600px;
    margin: 60px auto 80px;
    border: 1px solid rgba(0, 0, 0, 0.4);
    border-radius: 24px;
    overflow: hidden;
    .banner-item {
      display: flex;
      .info {
        width: 30%;
        padding: 60px 65px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        
        color: #101010;
        font-size: 18px;
        .title {
          font-size: 28px;
          font-weight: bold;
          margin-bottom: 60px;
        }
        .item {
          text-align: left;
          & + .item {
            margin-top: 40px;
          }
          .label {
            display: flex;
            align-items: center;
            font-size: 20px;
            font-weight: bold;
            margin-bottom: 10px;
            .van-icon {
              margin-right: 10px;
            }
          }
        }
      }
      .bg-box {
        position: relative;
        width: 70%;
        height: 598px;
        background: linear-gradient(-45.17deg, rgba(219,236,255,1) 0.25%,rgba(236,231,241,1) 59.01%,rgba(253,247,244,0.81) 94.87%);
        padding: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        .table-bg {
          height: 480px;
          width: 100%;
          border: 1px solid #6EB2FF;
          border-radius: 10px;
          overflow: hidden;
        }
        .item-img {
          position: absolute;
          right: 26px;
          bottom: 55px;
          width: 500px;
        }
        .item-img2 {
          position: absolute;
          left: 30px;
          bottom: 55px;
          width: 500px;
        }
        .item-img3 {
          position: absolute;
          right: 34px;
          top: 60px;
          width: 400px;
          background: #fff;
        }
      }
    }
  }

  .service-list {
    width: 1400px;
    margin: 100px auto 0;
    display: flex;
    flex-wrap: wrap;
    .item {
      width: 33.33%;
      margin-bottom: 40px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      
      img {
        width: 200px;
        height: 240px;
        object-fit: contain;
        margin-bottom: 6px;
      }
      .item-title {
        margin-bottom: 15px;
        font-size: 24px;
        font-weight: bold;
        color: #101010;
      }
      .item-desc {
        width: 250px;
        font-size: 16px;
        color: rgba(16, 16, 16, .5);
      }
    }
  }

  .good-box {
    width: 1400px;
    margin: 0 auto;
    display: flex;
    gap: 20px;
    .good-item {
      flex: 1;
      height: 340px;
      box-shadow: 2px 2px 8px 0px rgba(222,223,224,0.7);
      border-radius: 24px;
      overflow: hidden;
      
      background: linear-gradient(179.54deg, rgba(187,216,255,0.82) 20.46%,rgba(255,255,255,0.79) 56.39%,rgba(255,255,255,1) 89.33%);
      transition: all .3s;
      &:hover {
        transform: translateY(-4px);
      }
      .title {
        width: 100%;
        height: 120px;
        background: linear-gradient(129.36deg, rgba(64,125,255,1) 27.62%,rgba(121,212,255,0.82) 79.79%,rgba(131,235,255,1) 94.44%);
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        font-weight: bolder;
        font-size: 48px;
      }
      .item {
        padding: 20px 40px;
        text-align: left;
        .label {
          font-weight: bold;
          color: #101010;
          font-size: 20px;
          margin-bottom: 12px;
        }
        .desc {
          font-size: 18px;
          line-height: 28px;
          margin-bottom: 10px;
        }
        .van-icon {
          margin-right: 8px;
          margin-left: 4px;
        }
      }
    }
  }
}



// 小分比率适配
@media screen and (max-width: 1560px) {
  .law-page {
    min-width: 1200px;
    .top-banner {
      height: 540px;
      .banner-info {
        height: 540px;
        .title {
          font-size: 66px;
          line-height: 84px;
        }
        .space {
          height: 22px;
        }
        .info {
          font-size: 18px;
        }
        .btn {
          margin-top: 34px;
        }
      }
    }

    .law-main {
      padding-top: 52px;
      .section-title {
        margin-bottom: 52px;
        h2 {
          font-size: 42px;
        }
        .title-underline {
          width: 380px;
          height: 6px
        }
      }

      .law-table {
        width: 1200px;
        height: 520px;
        margin-bottom: 70px;
        .banner-item {
          .info {
            padding: 40px 45px;
            font-size: 16px;
            .title {
              font-size: 24px;
              margin-bottom: 48px;
            }
            .item {
              & + .item {
                margin-top: 32px;
              }
              .label {
                font-size: 18px;
              }
            }
          }
          .bg-box {
            height: 518px;
            .table-bg {
              height: 416px;
            }
            .item-img {
              width: 280px;
            }
          }
        }
      }

      .service-list {
        width: 1200px;
        .item { 
          img {
            width: 180px;
            height: 216px;
          }
          .item-title {
            margin-bottom: 18px;
            font-size: 22px;
          }
          .item-desc {
            font-size: 16px;
          }
        }
      }

      .good-box {
        width: 1200px;
        .good-item {
          height: 300px;
          .title {
            font-size: 42px;
            height: 100px;
          }
          .item {
            padding: 20px 30px;
            .desc {
              font-size: 16px;
            }
          }
        }
      }
    }
  }
}


// 小分比率适配
@media screen and (max-width: 1400px) {
  .law-page {
    min-width: 1080px;
    .top-banner {
      height: 500px;
      .banner-info {
        height: 500px;
        .title {
          font-size: 60px;
          line-height: 72px;
        }
        .space {
          height: 20px;
        }
        .info {
          font-size: 16px;
        }
        .btn {
          margin-top: 30px;
        }
      }
    }

    .law-main {
      padding-top: 46px;
      .section-title {
        margin-bottom: 36px;
        h2 {
          font-size: 36px;
        }
        .title-underline {
          width: 350px;
          height: 5px
        }
      }

      .law-table {
        width: 1080px;
        height: 480px;
        margin-bottom: 60px;
        .banner-item {
          .info {
            padding: 30px 33px;
            font-size: 14px;
            .title {
              font-size: 20px;
              margin-bottom: 40px;
            }
            .item {
              & + .item {
                margin-top: 26px;
              }
              .label {
                font-size: 16px;
              }
            }
          }
          .bg-box {
            height: 478px;
            .table-bg {
              height: 384px;
            }
            .item-img {
              width: 250px;
            }
          }
        }
      }

      .service-list {
        width: 1080px;
        .item { 
          img {
            width: 160px;
            height: 192px;
          }
          .item-title {
            margin-bottom: 16px;
            font-size: 20px;
          }
          .item-desc {
            font-size: 15px;
          }
        }
      }

      .good-box {
        width: 1080px;
        .good-item {
          height: 280px;
          .title {
            font-size: 38px;
            height: 90px;
          }
          .item {
            padding: 16px 24px;
            .desc {
              font-size: 15px;
            }
          }
        }
      }
    }
  }
}
</style>